import { render, staticRenderFns } from "./HeroBlock.vue?vue&type=template&id=7bbcaba0&"
import script from "./HeroBlock.vue?vue&type=script&lang=js&"
export * from "./HeroBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeroBlock.vue?vue&type=style&index=0&id=7bbcaba0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports